export const SEARCH_PANEL_MOBILE_PREFIX = "SearchPanelMobile";

export const SEARCH_PANEL_MOBILE_CLASSES = {
  root: `${SEARCH_PANEL_MOBILE_PREFIX}-root`,
  drawer: `${SEARCH_PANEL_MOBILE_PREFIX}-drawer`,
  toolbar: `${SEARCH_PANEL_MOBILE_PREFIX}-toolbar`,
};
